import { Koi } from '@ksyos/koi';
import { ProcessTaskType } from '@common/enums';

export type RecipientSchema = { recipientActivityIds: string[] };

export const recipientSchema = Koi.object({
    draftProcessTaskType: Koi.koi().enum(ProcessTaskType).optional(),
    recipientActivityIds: Koi.array().items(Koi.string().required()).required(),
});
